"use client";

import React from "react";
import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function WhereForeverBegins() {
  return <section data-section-id="240307" id="where-forever-begins" className="relative flex h-screen min-h-[700px] w-full flex-col items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <video autoPlay loop muted playsInline className="h-full w-full object-cover opacity-40 grayscale-[20%]" poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683483/img/garden_sunset_poster.png">
          <source src="https://cdn.coverr.co/videos/coverr-beautiful-garden-at-sunset-5241/1080p.mp4" type="video/mp4" />
        </video>
      </div>

      {}
      <div className="absolute inset-0 z-10 bg-primary/5" />
      <div className="absolute inset-0 z-10 bg-gradient-to-b from-background/80 via-transparent to-background" />

      {}
      <div className="relative z-20 flex w-full max-w-7xl flex-col items-center justify-center px-6 text-center">
        <div className="animate-in fade-in slide-in-from-bottom-8 duration-1000 ease-out fill-mode-forwards">
          <span className="mb-6 block font-mono text-xs font-medium tracking-[0.3em] uppercase text-secondary">
            The Estate at Vow
          </span>
          
          <h1 className="font-serif text-6xl font-light tracking-tight sm:text-7xl md:text-8xl lg:text-9xl text-primary mb-8">
            Where Forever <br className="hidden md:block" /> Begins
          </h1>

          <div className="mx-auto h-px w-24 bg-secondary/40 mb-8" />

          <p className="mx-auto max-w-2xl font-sans text-lg font-light leading-relaxed tracking-wide text-foreground/70 md:text-xl">
            An exquisite canvas for your most cherished moments, where architectural 
            grandeur meets the soft romance of nature.
          </p>

          <div className="mt-12 flex flex-col items-center gap-6">
            <Button size="lg" className="h-14 px-10 text-sm font-medium tracking-widest uppercase bg-primary text-primary-foreground hover:scale-105 transition-transform duration-500 rounded-md shadow-lg" asChild>
              <Link to="/BeginYourJourneyPage">Schedule a Private Tour</Link>
            </Button>
            
            <Link to="/EstatePage" className="font-mono text-[10px] uppercase tracking-[0.2em] text-foreground/60 hover:text-secondary transition-colors duration-300">
              Explore The Grounds
            </Link>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-12 left-1/2 z-20 -translate-x-1/2 opacity-0 animate-in fade-in duration-1000 fill-mode-forwards" style={{
      animationDelay: "1.2s"
    }}>
        <Link to="#estate-details" aria-label="Scroll down to next section" className="group flex flex-col items-center gap-3">
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-muted-foreground transition-colors group-hover:text-secondary">
            Scroll
          </span>
          <div className="relative flex h-10 w-px bg-secondary/20 overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-full bg-secondary animate-bounce origin-top" />
          </div>
        </Link>
      </div>
    </section>;
}